import React, { Component } from "react";
import { Modal, Form, Input, Row, Spin } from "antd";
import { inject, observer } from "mobx-react";
import co from "co";

const FormItem = Form.Item;

@Form.create({
	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class AddEditContentGroupForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll(callback);
	};

	getValues = () => {		
		return {
			name: this.props.form.getFieldValue("name")
		};
	};

	render() {
		return (
			<FormItem labelCol={{ span: 5 }} wrapperCol={{ span: 15 }} label="Name">
				{this.props.form.getFieldDecorator("name", {
					rules: [
						{
							required: true,
							message: "Please enter content group name"
						}
					]
				})(<Input placeholder="My great SEO content" />)}
			</FormItem>
		);
	}
}

@inject("rootStore")
@observer
class AddEditContentGroupDialog extends Component {
	mapPropsToFields = () => {
		const {
			rootStore: { contentGroupsStore }
		} = this.props;

		const ui = contentGroupsStore.ui;

		if (ui.editedContentGroup == null) {
			//Means that we are adding a new content group
			return {
				name: Form.createFormField({
					value: undefined
				})
			};
		} else {
			return {
				name: Form.createFormField({
					value: ui.editedContentGroup.name
				})
			};
		}
	};

	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	createOrRenameContentGroup = name => {
		const {
			rootStore: { contentGroupsStore }
		} = this.props;

		const ui = contentGroupsStore.ui;

		co(
			function*() {
				const response = yield this.validateForm();
				if (response != null) return;
				const formValues = this.internalForm.getValues();

				if (ui.editedContentGroup == null) {
					contentGroupsStore.createContentGroup({ name: formValues.name });
				} else {
					contentGroupsStore.remoteRenameContentGroup({
						name: formValues.name,
						id: ui.editedContentGroup.id
					});
				}
			}.bind(this)
		);
	};

	hideDialog = () => {
		const {
			rootStore: { contentGroupsStore }
		} = this.props;

		contentGroupsStore.hideAddEditContentGroupDialog();
	};

	render() {
		const {
			rootStore: { contentGroupsStore }
		} = this.props;

		const ui = contentGroupsStore.ui;

		let title = "";
		if (ui.editedContentGroup == null) {
			title = "New Content Group";
		} else {
			title = "Rename Content Group";
		}

		const spinning =
			ui.creatingContentGroup || ui.renamingContentGroup;

		return (
			<Modal
				visible={ui.addEditContentGroupDialogVisible}
				title={title}
				okText="Save"
				onCancel={this.hideDialog}
				onOk={this.createOrRenameContentGroup}
			>
				<Spin spinning={spinning}>
					<AddEditContentGroupForm
						fields={this.mapPropsToFields()}
						wrappedComponentRef={internalForm => {
							this.internalForm = internalForm;
						}}
					/>
				</Spin>
			</Modal>
		);
	}
}

export default AddEditContentGroupDialog;
